var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { API_MODEL_TYPE_SCALPING, CRITERIA_TRAIL_LOSS, CRITERIA_TRAIL_PROFIT, } from "src/pages/smart-strategies/smart-strategies-constant";
import { SESSION_KEYS, getDataFromSession, setDataInSession, } from "./session-storage";
import { getSessionTransferWrapper, getSsoSessionApi, } from "src/apis/dashboard";
import { SMARTALGOLOCALSTORAGEKEY } from "./constant";
import { ToastUtils } from "./toast-utils";
import moment from "moment";
const { REACT_APP_ENV } = process.env;
export const smartLogin = (relogin) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    try {
        //const fetchSessionTransferApi = await getSessionTransferWrapperDummy();
        const fetchSessionTransferApi = yield getSessionTransferWrapper();
        if (((_a = fetchSessionTransferApi === null || fetchSessionTransferApi === void 0 ? void 0 : fetchSessionTransferApi.data) === null || _a === void 0 ? void 0 : _a.body.Status) === 0) {
            const accessToken = (_b = fetchSessionTransferApi === null || fetchSessionTransferApi === void 0 ? void 0 : fetchSessionTransferApi.data) === null || _b === void 0 ? void 0 : _b.body.AccessToken;
            //const fetchModernAlgoSession = await getModernalgoSession();
            const fetchModernAlgoSession = yield getSsoSessionApi(accessToken);
            if (((_c = fetchModernAlgoSession === null || fetchModernAlgoSession === void 0 ? void 0 : fetchModernAlgoSession.data) === null || _c === void 0 ? void 0 : _c.status) === "SUCCESS") {
                //fetchSmartStrategies();
                const apiKey = (_d = fetchModernAlgoSession === null || fetchModernAlgoSession === void 0 ? void 0 : fetchModernAlgoSession.data) === null || _d === void 0 ? void 0 : _d.Token;
                if (apiKey) {
                    setDataInSession(SESSION_KEYS.SMART_ALGO_KEY, apiKey, true);
                    setSmartApiKeyInLocalStorage("SUCCESS", apiKey, "");
                    return true;
                }
                else {
                    throw "Something went wrong!";
                }
            }
            else {
                throw "Something went wrong!";
            }
        }
        else {
            throw "Something went wrong!";
        }
    }
    catch (error) {
        //for uat
        // if (REACT_APP_ENV === "development") {
        //   // setSmartApiKeyInLocalStorage(
        //   //   "SUCCESS",
        //   //   "salkjsaWVlSIhx0QgrDlahOcYsGI51DTDyOnDQjkl2g3tB%2b4taMyrH71Ybm1I%2fcPn%2fKlwQvgsjagskahjks",
        //   //   ""
        //   // );
        //   return true;
        // }
        // console.log("getSessionTransferWrapperLogin" + error);
        setErrorSmartApiKeyInLocalStorage(" " + error);
        ToastUtils.error("" + error);
        return false;
    }
});
export const performLoginCheck = (relogin) => {
    const localStorage_obj = getSmartApiKeyFromLocalStorage();
    //fresh local storage login --- always login
    if (localStorage_obj.key === "" && localStorage_obj.status === "") {
        return true;
    }
    //Failed  ---
    if (localStorage_obj.key === "" && localStorage_obj.status === "FAILED") {
        if (relogin) {
            return true;
        }
        else {
            const iscurrentDate = moment(localStorage_obj.timestamp).isSame(new Date(), "day");
            if (iscurrentDate) {
                return false;
            }
            else {
                return true;
            }
        }
    }
    //sucess ---
    if (localStorage_obj.key !== "" && localStorage_obj.status === "SUCCESS") {
        const iscurrentDate = moment(localStorage_obj.timestamp).isSame(new Date(), "day");
        if (iscurrentDate) {
            return false;
        }
        else {
            return true;
        }
    }
    return false;
};
export const checkInvalidSession = (data) => {
    if ((data === null || data === void 0 ? void 0 : data.status) === "FAILURE" &&
        (data === null || data === void 0 ? void 0 : data.reason) === "Authorization not Matching") {
        unsetSmartApiKeyInLocalStorage();
        return true;
    }
    else {
        return false;
    }
};
export const unsetSmartApiKeyInLocalStorage = () => localStorage.removeItem(SMARTALGOLOCALSTORAGEKEY);
export const getSmartApiKeyFromLocalStorage = () => {
    const samrt_Api_Key = getDataFromSession(SESSION_KEYS.SMART_ALGO_KEY);
    if (samrt_Api_Key) {
        try {
            const obj = samrt_Api_Key;
            return obj;
        }
        catch (error) {
            const obj = { status: "", key: "", timestamp: new Date(), message: "" };
            setDataInSession(SESSION_KEYS.SMART_ALGO_KEY, obj, true);
            return obj;
        }
    }
    else {
        const obj = { status: "", key: "", timestamp: new Date(), message: "" };
        setDataInSession(SESSION_KEYS.SMART_ALGO_KEY, obj, true);
        return obj;
    }
};
const setSmartApiKeyInLocalStorage = (status, key, message) => {
    const obj = {
        status: status,
        key: key,
        timestamp: new Date(),
        message: message,
    };
    setDataInSession(SESSION_KEYS.SMART_ALGO_KEY, obj, true);
};
const setErrorSmartApiKeyInLocalStorage = (message) => {
    const obj = {
        status: "FAILED",
        key: "",
        timestamp: new Date(),
        message: message,
    };
    setDataInSession(SESSION_KEYS.SMART_ALGO_KEY, obj, true);
};
export const LoginWrapper = (relogin, callbackFunc) => {
    if (performLoginCheck(relogin)) {
        smartLogin(relogin)
            .then((result) => {
            if (result) {
                callbackFunc();
            }
            else {
                console.error("Unable to login");
            }
        })
            .catch((error) => alert(error.message));
    }
    else {
        callbackFunc();
        // console.log("No login performed!");
    }
};
const abortableFetch = (request, opts) => {
    const controller = new AbortController();
    const signal = controller.signal;
    return {
        abort: () => controller.abort(),
        request: () => fetch(request, Object.assign(Object.assign({}, opts), { signal })),
    };
};
export const exitParameterValidation = (exitParameterData) => {
    if (exitParameterData.strategiesTypeModify === API_MODEL_TYPE_SCALPING) {
        if (isScalpingParamValid(exitParameterData.AT_ScalpingParameters)) {
            // return true;
            if (exitParameterData.AT_TargetParameters[0].Criteria !== "") {
                if (exitParameterData.AT_TargetParameters[0].Criteria ===
                    CRITERIA_TRAIL_PROFIT &&
                    exitParameterData.AT_TargetParameters[0].FixedProfit !== "" &&
                    exitParameterData.AT_TargetParameters[0].Type !== "" &&
                    exitParameterData.AT_TargetParameters[0].Xvalue !== "") {
                    return true;
                }
                else if (exitParameterData.AT_TargetParameters[0].Criteria ===
                    CRITERIA_TRAIL_LOSS &&
                    exitParameterData.AT_ExitParameters[0].FixedLoss !== "" &&
                    exitParameterData.AT_TargetParameters[0].Type !== "" &&
                    exitParameterData.AT_TargetParameters[0].Xvalue !== "") {
                    return true;
                }
                return false;
            }
            else if (exitParameterData.AT_TargetParameters[0].Criteria === "") {
                if (exitParameterData.AT_ExitParameters[0].FixedLoss !== "" ||
                    exitParameterData.AT_TargetParameters[0].FixedProfit !== "") {
                    return true;
                }
            }
            return true;
        }
    }
    else {
        if (exitParameterData.AT_TargetParameters &&
            exitParameterData.AT_ExitParameters) {
            if (exitParameterData.AT_TargetParameters.length === 0 &&
                exitParameterData.AT_ExitParameters.length === 0)
                return true;
            else if (exitParameterData.AT_TargetParameters.length > 0 &&
                exitParameterData.AT_ExitParameters.length > 0) {
                if (exitParameterData.AT_TargetParameters[0].Criteria !== "") {
                    if (exitParameterData.AT_TargetParameters[0].Criteria ===
                        CRITERIA_TRAIL_PROFIT &&
                        exitParameterData.AT_TargetParameters[0].FixedProfit !== "" &&
                        exitParameterData.AT_TargetParameters[0].Type !== "" &&
                        exitParameterData.AT_TargetParameters[0].Xvalue !== "") {
                        return true;
                    }
                    else if (exitParameterData.AT_TargetParameters[0].Criteria ===
                        CRITERIA_TRAIL_LOSS &&
                        exitParameterData.AT_ExitParameters[0].FixedLoss !== "" &&
                        exitParameterData.AT_TargetParameters[0].Type !== "" &&
                        exitParameterData.AT_TargetParameters[0].Xvalue !== "") {
                        return true;
                    }
                    return false;
                }
                else if (exitParameterData.AT_TargetParameters[0].Criteria === "") {
                    if (exitParameterData.AT_ExitParameters[0].FixedLoss !== "" ||
                        exitParameterData.AT_TargetParameters[0].FixedProfit !== "") {
                        return true;
                    }
                    return false;
                }
                return false;
            }
        }
        return false;
    }
    return false;
};
const isScalpingParamValid = (scalpingParam) => {
    if (!scalpingParam) {
        return false;
    }
    if ((scalpingParam[0].DN_Pts == 0
        ? scalpingParam[0].UP_Pts
        : scalpingParam[0].DN_Pts) == 0 ||
        scalpingParam[0].NoOfTimes == 0)
        return false;
    else if ((scalpingParam[0].DN_Pts == 0
        ? scalpingParam[0].UP_Pts
        : scalpingParam[0].DN_Pts) === "" ||
        scalpingParam[0].NoOfTimes === "")
        return false;
    else
        return true;
};
// const App = () => {
//   const [data, setData] = useState({ main: { temp: 'no data' } });
//   const { abort, request } = abortableFetch(WHEATHER_URL)
//   const requestData = async () => {
//     const response = await request();
//     setData(await response.json())
//   };
//   const cancelDataRequest = () => {
//     abort();
//   }
// };
